import axios from "axios";
import { backend_url } from "@/constants";
/**
 * Validates if a business slug exists.
 * @param slug The business slug to validate
 * @param signal Optional AbortSignal to cancel the request
 * @returns Promise that resolves to true if the slug exists, false otherwise
 */
export const validateSlug = async (
  slug: string,
  signal?: AbortSignal
): Promise<boolean> => {
  try {
    const response = await axios.head(`${backend_url}/api/${slug}/exists/`, {
      withCredentials: true,
      signal,
    });
    return response.status === 200;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return false;
    }
    throw error;
  }
};
